import React from 'react';
import '../../components/global.scss';
import ViewMenuBottom from './ViewMenuBottom';

const Menu = props => (
    <ViewMenuBottom
        estabelecimentosFavoritos={props.estabelecimentosFavoritos}
        userLocation={props.userLocation}
        setSelectedEstabelecimento={props.setSelectedEstabelecimento}
        favoritar={props.favoritar}
        estabelecimentos={props.estabelecimentos}
        selectedMkr={props.selectedMkr}
        />
);

export default Menu;